export default "__VITE_ASSET__CUNxVKwx__"